import KpiServer from '@/api/kpi/index'
import PersonServer from '@/api/person/index'
import AthubCloudApi from '@/api/athubCloud'

//合并人员与职级信息
function combinePersonInfo(personList, deptPostList) {
    for (let i = 0; i < personList.length; i++) {
        for (let j = 0; j < deptPostList.length; j++) {
            if (personList[i].title == parseInt(deptPostList[j].id)) {
                personList[i].titleLevel = deptPostList[j].level;
                break;
            }
        }
    }
}

export default {

    namespaced: true,

    state: {

        kpiResultPageInfo: {}

    },

    getters: {

        kpiResultPageInfo(state) {
            return state.kpiResultPageInfo;
        },

    },

    mutations: {

        setKpiResultPageInfo(state, payload) {
            state.kpiResultPageInfo = payload;
        },

    },

    actions: {

        async getKpiResultPageInfo({commit}, params) {

            let personList = await PersonServer.personApi.fetchByRedis({'department': params.kpiDto.deptid});
            let deptPostList = await AthubCloudApi.fetchDeptpostList();
            combinePersonInfo(personList, deptPostList);

            //本月绩效得分查询
            await KpiServer.kpiResult.page(params, {
                headers: {
                    orgId: localStorage.getItem("authorg"),
                    sites: localStorage.getItem("authsites"),
                }
            }).then((res) => {
                let tableData = res.data.data.pageData;
                let total = res.data.data.total;

                for (let i = 0; i < tableData.length; i++) {
                    for (let j = 0; j < personList.length; j++) {
                        if (tableData[i].username == personList[j].personid) {
                            tableData[i].realname = personList[j].realName;
                            tableData[i].titleLevel = `G${personList[j].titleLevel}`;
                            break;
                        }
                    }
                }

                tableData.sort((a, b) => {
                    if (a.kpiDto.kpidate > b.kpiDto.kpidate) {
                        return -1;
                    } else if (a.kpiDto.kpidate < b.kpiDto.kpidate) {
                        return 1
                    } else {
                        if (a.score > b.score) {
                            return 1;
                        } else if (a.score < b.score) {
                            return -1
                        } else {
                            if (a.titleLevel > b.titleLevel) {
                                return -1;
                            } else if (a.titleLevel < b.titleLevel) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }
                    }
                });

                tableData = tableData.slice((params.currentPage - 1) * params.pageSize, params.currentPage * params.pageSize);

                commit("setKpiResultPageInfo", {
                    tableData: tableData,
                    total: total
                });
            });

        },


    },

}